/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type WalletStatus = 1 | 2 | 3 | 4;

export const WalletStatus = {
    NUMBER_1: 1 as WalletStatus,
    NUMBER_2: 2 as WalletStatus,
    NUMBER_3: 3 as WalletStatus,
    NUMBER_4: 4 as WalletStatus
};